import script from "./Channels.vue?vue&type=script&setup=true&lang=js"
export * from "./Channels.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__